import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 8.66634H8.66668V11.9997C8.66668 12.3663 8.36668 12.6663 8.00001 12.6663C7.63334 12.6663 7.33334 12.3663 7.33334 11.9997V8.66634H4.00001C3.63334 8.66634 3.33334 8.36634 3.33334 7.99967C3.33334 7.63301 3.63334 7.33301 4.00001 7.33301H7.33334V3.99967C7.33334 3.63301 7.63334 3.33301 8.00001 3.33301C8.36668 3.33301 8.66668 3.63301 8.66668 3.99967V7.33301H12C12.3667 7.33301 12.6667 7.63301 12.6667 7.99967C12.6667 8.36634 12.3667 8.66634 12 8.66634Z",
		fill: "currentColor"
	})
});
export default SvgPlus;
